import { StackScreenProps } from "@react-navigation/stack";
import { EditProductRootParamList } from "../../../../types";
import { useSelectedProductEntityContextProvider } from "../../utils";
import { useTranslation } from "../../../../utilities/i18n";
import { EmptyList } from "../../../../components/EmptyList";
import React from "react";
import { FlatActionList, Page } from "@towersystems/roam-common-native";

export type ProductViewSerialNumbersScreenProps = StackScreenProps<
  EditProductRootParamList,
  "ProductViewSerialNumbersScreen"
>;

export const ProductViewSerialNumbersScreen =
  ({}: ProductViewSerialNumbersScreenProps) => {
    const { product } = useSelectedProductEntityContextProvider();

    const { t } = useTranslation("product");

    const allSerialNumbers = React.useMemo(() => {
      const result = [];

      for (const l of product.locationInventoryPricing) {
        if (!l.serialNumbers) {
          continue;
        }
        for (const s of l.serialNumbers) {
          result.push({
            location: l.location?.name ?? "--",
            serialNumber: s,
          });
        }
      }
      return result;
    }, []);

    const emptyTagsMarkup = allSerialNumbers.length === 0 && (
      <EmptyList
        title={t("common:empty")}
        style={{
          alignItems: "flex-start",
        }}
      />
    );

    return (
      <Page title={t("manage_serial_numbers_title")}>
        {emptyTagsMarkup}
        <FlatActionList
          items={allSerialNumbers.map((as) => ({
            key: as.serialNumber,
            title: as.serialNumber,
            secondaryTitle: as.location,
          }))}
        />
      </Page>
    );
  };
